<template>
  <div class="container">
    <div class="money-block frankreich">
      <div class="money-container">
        <div class="money-label">(Dukaten)</div>
        <div><input class="money" @focus="$event.target.select()" id="money-dukaten" v-model="money.dukaten" @keyup="recalc('dukaten')"></div>
      </div>
      <div class="money-container">
        <div class="money-label">(Konventionstaler)</div>
        <div><input class="money" @focus="$event.target.select()" id="money-konvtaler" v-model="money.konvtaler" @keyup="recalc('konvtaler')"></div>
      </div>
      <div >
        <div class="money-label">Franc</div>
        <div><input class="money" @focus="$event.target.select()" id="money-franc" v-model="money.franc" @keyup="recalc('franc')"></div>
      </div>
      <div class="money-container">
        <div class="money-label">Décimes</div>
        <div><input class="money" @focus="$event.target.select()" id="money-decimes" v-model="money.decimes" @keyup="recalc('decimes')"></div>
      </div>
      <div class="money-container">
        <div class="money-label">Centimes</div>
        <div><input class="money" @focus="$event.target.select()" id="money-centimes" v-model="money.centimes" @keyup="recalc('centimes')"></div>
      </div>
    </div>

    <div class="money-block preussen">
      <div class="money-container">
        <div class="money-label">Friedrichsdor</div>
        <div><input class="money" @focus="$event.target.select()" id="money-friedrichsdor" v-model="money.friedrichsdor" @keyup="recalc('friedrichsdor')"></div>
      </div>
      <div class="money-container">
        <div class="money-label">Mark (Preußen)</div>
        <div><input class="money" @focus="$event.target.select()" id="money-mark_pr" v-model="money.mark_pr" @keyup="recalc('mark_pr')"></div>
      </div>
      <div class="money-container">
        <div class="money-label">Taler</div>
        <div><input class="money" @focus="$event.target.select()" id="money-taler" v-model="money.taler" @keyup="recalc('taler')"></div>
      </div>
      <div class="money-container">
        <div class="money-label">Groschen</div>
        <div><input class="money" @focus="$event.target.select()" id="money-groschen" v-model="money.groschen" @keyup="recalc('groschen')"></div>
      </div>
      <div class="money-container">
        <div class="money-label">Pfennige</div>
        <div><input class="money" @focus="$event.target.select()" id="money-pfennige" v-model="money.pfennige" @keyup="recalc('pfennige')"></div>
      </div>
    </div>

    <div class="money-block habsburg">
      <div class="money-container">
        <div class="money-label">Goldgulden</div>
        <div><input class="money" @focus="$event.target.select()" id="money-goldgulden" v-model="money.goldgulden" @keyup="recalc('goldgulden')"></div>
      </div>
      <div class="money-container">
        <div class="money-label">Mark (Habsburg)</div>
        <div><input class="money" @focus="$event.target.select()" id="money-mark_au" v-model="money.mark_au" @keyup="recalc('mark_au')"></div>
      </div>
      <div class="money-container">
        <div class="money-label">Gulden</div>
        <div><input class="money" @focus="$event.target.select()" id="money-gulden" v-model="money.gulden" @keyup="recalc('gulden')"></div>
      </div >
      <div class="money-container">
        <div class="money-label">Kreuzer</div>
        <div><input class="money" @focus="$event.target.select()" id="money-kreuzer" v-model="money.kreuzer" @keyup="recalc('kreuzer')"></div>
      </div>
      <div class="money-container">
        <div class="money-label">Heller</div>
        <div><input class="money" @focus="$event.target.select()" id="money-heller" v-model="money.heller" @keyup="recalc('heller')"></div>
      </div>
    </div>

  </div>
</template>

<script>
import { reactive } from 'vue'
export default {
  name: 'WSCalc',
  setup() {
    const money = reactive({
      dukaten: 0,
      konvtaler: 0,
      franc: 0,
      decimes: 0,
      centimes: 0,
      friedrichsdor: 0,
      mark_pr: 0,
      taler: 0,
      groschen: 0,
      pfennige: 0,
      goldgulden: 0,
      mark_au: 0,
      gulden: 0,
      kreuzer: 0,
      heller: 0,
    })

    return {
      money,
    }
  },
  methods: {
    recalc: function(src) {
      const convToBase = {
        dukaten: 4788000,
        konvtaler: 4788000,
        franc: 36000,
        decimes: 3600,
        centimes: 360,

        friedrichsdor: 2394000,
        mark_pr: 1915200,
        taler: 136800,
        groschen: 5700,
        pfennige: 475,

        goldgulden: 2394000,
        mark_au: 1915200,
        gulden: 95760,
        kreuzer: 1596,
        heller: 399,
      }

      let baseUnits = this.money[src] * convToBase[src]
      for (const [target] of Object.entries(convToBase)) {
        if (src !== target) {
          this.money[target] = Math.round((baseUnits / convToBase[target]) * 1000) / 1000
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    margin: auto;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .money {
    width: 80px;
    text-align: center;
    font-size: 12pt;
    font-weight: bold;
  }

  .preussen {
    background-color: #777777;
  }

  .frankreich {
    background-color: #6666aa;
  }

  .habsburg {
    background-color: #aa5555;
  }

  .money-label {
    color: black;
    padding: 0;
    font-size: 14pt;
  }

  .money-container {
    padding: 3px;
    flex-grow: 4;
  }

  .money-block {
    margin: auto;
    margin-top: 10px;
    padding-bottom: 10px;
    min-width: 200px;
    max-width: 400px;

    box-sizing: content-box;
    border-width: 8px;
    border-style: solid;
    border-image: linear-gradient(to right bottom, #FFFFFF 0%, #FFFFAC 8%, #D1B464 25%, #5d4a1f 62.5%, #5d4a1f 100%);
    border-image-slice: 1;

    border-radius: 25px;

  }
</style>
